import { Component, PropSync, Vue } from "vue-property-decorator";

@Component<Title>({
  components: {}
})
export default class Title extends Vue {
  @PropSync("title", { type: String })
  syncedTitle!: string;

  @PropSync("isShowBT", { type: Boolean })
  syncedIsShowBT!: boolean;
}